import { axiosInstance } from '~/common/utils/api.util';

import type { ApiResponse } from '~/common/types/api.type';
import type { DashboardSummary } from '~/features/dashboard/types/dashboard.type';

/**
 * 대시보드 요약 통계 조회
 * @description 대시보드 요약 통계를 조회합니다
 * @endpoint GET /admin/dashboard/summary
 */
export function getDashboardSummaryApi() {
  return axiosInstance.get<ApiResponse<DashboardSummary>>('/admin/dashboard/summary');
}
